<template>
  <div>
    <van-nav-bar fixed placeholder title left-text="返回" left-arrow>
      <template #left>
        <img v-if="logo" class="logo" :src="global.getStaticFilePath(company.extendInfo.logo)"/>
        <span v-if="!sysName" class="f-16 f-w-b">{{ sysName }}</span>
      </template>
      <template #right>
        <!-- <a v-if="company && company.tel" :href="'tel:'+company.tel"> -->
        <a @click="contactUsShow=true">
          <van-icon name="service-o" size="20" color="#414141"/>
          <span class="subtitle-color">客服</span>
        </a>
        <!-- <van-icon class="m-l-20" dot name="chat-o" size="20" color="#414141" /> -->
      </template>
    </van-nav-bar>
    <van-popup v-model="contactUsShow" position="left" :style="{height:'100%', width: '100%' }">
      <van-nav-bar title="联系客服" left-arrow @click-left="contactUsShow=false"/>
      <div class="contactus m-t-20">
        <div v-if="company && company.extendInfo && company.extendInfo.contact && company.extendInfo.contact.qrcode">
          <van-image :src="global.getStaticFilePath(company.extendInfo.contact.qrcode)"/>
          <p>扫码加客服或致电下列号码</p>
        </div>
        <p class="tel">联系方式：<a
            v-if="company && company.extendInfo && company.extendInfo.contact && company.extendInfo.contact.tel"
            :href="'tel:'+company.extendInfo.contact.tel">{{ company.extendInfo.contact.tel }}</a></p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {NavBar, Icon, Popup, Image as VanImage} from "vant";

export default {
  name: "MainTopNav",
  props: ["company"],
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [VanImage.name]: VanImage,
  },
  data() {
    return {
      contactUsShow: false,
    };
  },
  computed: {
    logo() {
      return (this.company && this.company.extendInfo && this.company.extendInfo.logo) || ""
    },

    sysName() {
      return (this.company && this.company.memberSystemName) || ""
    }
  }
};
</script>
